<template>
  <div class="d-flex d-md-block flex-row mb-2 mb-md-0">
    <div v-if="label" class="text-primary mr-3 mr-md-0">{{label}}:</div>
    <div class="align-items-center">{{value}}</div>
  </div>
</template>

<script>
export default {
  name: 'DetailStacked',
  props: {
    label: {
      type: String,
      default: '',
    },
    value: {},
  },
};
</script>
